// extracted by mini-css-extract-plugin
export default {"section":"IntegrationSelectSetting-module__section--Gh9p+"};